import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Grid } from '@material-ui/core';
import { toggleRightDrawer, setFocusElement, setReRender } from '../../../store/global/actions';
import { marginBottom } from "../../../config/styles"
import { basic, validationMessages } from '../../../config/validations';
import { useForm } from "react-hook-form";
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import {IconSelector} from "../../atoms/IconSelectorV2";
import { invokeGetService, invokePostService, setHeaderName } from '../../../store/global/actions';
import { findIconSource, formatFetchedCustomIcons, generateIconFileName, validateNonAsciiChars } from '../../../utils/commonUtils';
import { useBottomDrawerContext } from '../bluePrintComponents/BottomDrawer/BottomDrawerContext';
import { getBottomDrawerStatus } from '../../../store/global/selectors';


export default function Details({ element, onCompletion, onClose }) {
    const dispatch = useDispatch();
    const [digitalTwin, setDigitalTwin] = useState(element);
    const [loading, setLoading] = useState(false);
    const [prevIconName, setPrevIconName] = useState("");
    const isBottomDrawerOpen = useSelector(getBottomDrawerStatus);



    const setDisableUpdate = useBottomDrawerContext()?.setDisableUpdate; 
    const setShowUpdateButton = useBottomDrawerContext()?.setShowUpdateButton; 
    const setUpdateButtonText = useBottomDrawerContext()?.setUpdateButtonText;
    const setOnActionCompletion = useBottomDrawerContext()?.setOnActionCompletion;
    const setOnActionClose = useBottomDrawerContext()?.setOnActionClose;
    if(isBottomDrawerOpen){
        setShowUpdateButton(true);
        setUpdateButtonText("Update");
    }
    

    const [icon, setIcon] = useState(null);
    const { register, handleSubmit, formState: { errors }, reset, setError, watch } = useForm({
        defaultValues: {
            name: digitalTwin?.name,
            desc: digitalTwin?.desc
        }
    });

    const nameValue = watch("name");

    useEffect(() => {
        dispatch(invokeGetService('getClusterlet', [element.id])).then(res => {
            if (res?.status === true) {
                setDigitalTwin(res?.data);
                setIcon(formatFetchedCustomIcons(res?.data));
                setPrevIconName(res?.data?.icon);
                reset({
                    name: res?.data?.name,
                    desc: res?.data?.attributes?.desc
                });

                dispatch(setHeaderName(res?.data?.name))

            } else {
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            } 
        })
    }, [])

    const cancelUpdation = () => {
        dispatch(toggleRightDrawer())
    }


    const messages = { ...validationMessages, validate: 'This name is already used' };


    const onUpdateDigitalTwin = async ({ name, desc }) => {
        const editedDigitalTwin = {
            name,
            attributes: { ...digitalTwin.attributes, desc },
            type: digitalTwin.type
        }

        if(prevIconName != generateIconFileName(icon)){
            editedDigitalTwin.icon = generateIconFileName(icon)
            editedDigitalTwin.iconSource = findIconSource(icon)
        }

        setLoading(true);
        dispatch(invokePostService('editClusterlet', { clusterlet: editedDigitalTwin }, [element.id])).then(res => {
            setLoading(false);
            if (res?.status === true) {
                if (digitalTwin.name !== name) {
                    dispatch(setFocusElement({ id: digitalTwin._id, type: 'clusterlet', templateId: '', name: name, icon: digitalTwin?.icon, desc: digitalTwin?.attributes?.desc }));
                }
                onCompletion('Digital Twin', 'edit', undefined, name)
            } else {
                if (res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                }
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
        });

    }
    

    return (
        <>
            <Grid xs={12} style={marginBottom}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    variant="outlined"
                    placeholder={"Name"}
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>


            <Grid xs={12} style={marginBottom}>
                <TextField
                    id="desc"
                    type={"text"}
                    fullWidth
                    rows={4}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    multiline
                    name="desc"
                    inputRef={register({ required: false, validate: validateNonAsciiChars })}
                    error={errors?.desc}
                    helperText={errors?.desc?.message || ''}
                />
            </Grid>

            <Grid xs={12} style={{ display: "flex", marginBottom: 20 }}>
                <IconSelector setSelectedIcon={setIcon} selectedIcon={icon} defaultSearchTag={nameValue}/>
            </Grid>




            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <UpdateCancel updateDisable={loading} content={loading ? 'Updating..' : 'Update'} onUpdate={handleSubmit(onUpdateDigitalTwin)} onCancel={cancelUpdation} typesNotIn={['transaction', 'view']} />
            </Grid>
        </>

    )
}
